import routerOptions0 from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}